
(function(){
  var bar=document.getElementById('fxbar');
  (document.querySelector('.ppc')||document.body).classList.add('has-bar');
  function onScroll(){ bar.classList.toggle('on', window.scrollY > 560); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  var KEY='fxOfferEnd_postpartum-core', H=3600000;
  function rd(){try{return +localStorage.getItem(KEY)||0}catch(e){return 0}}
  var end=rd(), now=Date.now();
  if(!end||end<=now||end-now>H){end=now+H;try{localStorage.setItem(KEY,end)}catch(e){}}
  var els=document.querySelectorAll('[data-fxcd]');
  function two(n){return n<10?'0'+n:''+n}
  function tick(){
    var left=Math.max(0,end-Date.now()), s=Math.round(left/1000);
    var t=Math.floor(s/3600)+':'+two(Math.floor(s%3600/60))+':'+two(s%60);
    for(var i=0;i<els.length;i++) els[i].textContent=t;
    if(left<=0) clearInterval(id);
  }
  var id=setInterval(tick,1000); tick();
})();
